import {
    ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION,
    ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION_VENDORS,
} from '@/data/url'
import apiClient from '@/services/apiClient'
import { unwrapApiData } from '@/services/apiEnvelope'

const fetchLiveSearchConfig = async () => {
    const response = await apiClient.get(ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION)
    return unwrapApiData(response, null)
}

const createLiveSearchVendor = async (vendor) => {
    const response = await apiClient.post(ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION_VENDORS, { vendor })
    return unwrapApiData(response, null)
}

const updateLiveSearchVendor = async (originalSource, vendor) => {
    const response = await apiClient.patch(ADMIN_LIVE_SEARCH_FLOW_CONFIGURATION_VENDORS, {
        original_source: originalSource,
        vendor,
    })
    return unwrapApiData(response, null)
}

export default {
    fetchLiveSearchConfig,
    createLiveSearchVendor,
    updateLiveSearchVendor,
}
